import { gql } from "graphql-tag";

/**
 *
 * Gets pss ussing uuid
 * Here is a variable example
 * { "uuid": "(uuid,eq,asdhfgf)" }
 */
export const GET_PSSByUUID = gql`
  query GETPSSByUUID($uuid: String!) {
    pssList: ProductSlotStateList(where: $uuid) {
      id: Id
      uuid: Uuid
      booking: ProductSlotBookingRead {
        id: Id
        token: GoerToken
      }
      GroupRead {
        groupUuid: Uuid
      }
    }
  }
`;

/**
 * Get addons using bookingIds
 */
export const GET_ADDONS = gql`
  query GET_ADDONS($bookingIds: [String]!) {
    ProductSlotStateList(
      condition: {
        BookingId: { in: $bookingIds }
        MainTicketId: { neq: "null" }
        PaymentStatus: { eq: "4" }
        BookingStatus: { eq: "3" }
      }
    ) {
      bookingId: BookingId
      categoryName: CategoryName
      GroupRead {
        groupUuid: Uuid
      }
    }
  }
`;

/**
 * Get membership pss using voucher code
 * @param {String} voucherCode
 */
export const GET_MEMBERSHIP_BY_VOUCHER_CODE = gql`
  query GET_MEMBERSHIP_BY_VOUCHER_CODE($condition: String!) {
    PromoCodeList(where: $condition, sort: "-id") {
      ProductSlotStateList {
        bookingStatus: BookingStatus
        token: Token
        type: Type
        GroupRead {
          groupUuid: Uuid
        }
      }
    }
  }
`;

/**
 * Get pssList using uuids
 * @param {String} uuids
 */
export const GET_PSSListByUUIDs = gql`
  query GET_PSSListByUUIDs($uuids: [String]!) {
    pssList: ProductSlotStateList(condition: { Uuid: { in: $uuids } }) {
      uuid: Uuid
      promocode: PromoCodeRead {
        code: Code
        codeUnique: CodeUnique
        promoCodeCampaign: PromoCodeCampaignRead {
          id: Id
          startDateTime: StartDateTime
          endDateTime: EndDateTime
          ticketStartDate: TicketStartDate
          ticketEndDate: TicketEndDate
          isValidAllDates: IsValidAllDates
          cancelled: Cancelled
        }
      }
      GroupRead {
        groupUuid: Uuid
      }
    }
  }
`;
